export interface HeroContent {
  eyebrow: string;
  headline: string;
  subheadline: string;
  cta: string;
  trustSignals: string[];
  socialProof: string;
  keywords: string[];
}

export const heroContent: Record<'premium' | 'energetic', HeroContent> = {
  premium: {
    eyebrow: "Dla uczniów przygotowujących się do matury i egzaminu ósmoklasisty",
    headline: "Zdaj maturę z matematyki bez stresu",
    subheadline: "Skuteczne przygotowanie, które zamienia niepewność w pewność siebie przed egzaminem. Gwarantujemy wzrost wyników i spokojne podejście do najważniejszego testu.",
    cta: "🎯 Umów lekcje teraz",
    trustSignals: [
      "98% uczniów zdaje maturę powyżej oczekiwań",
      "Średni wzrost wyników o 35 punktów",
      "Tylko 8 tygodni do sukcesu"
    ],
    socialProof: "47 uczniów zapisało się w tym tygodniu",
    keywords: ["matura matematyka", "przygotowanie do matury", "korepetycje matematyka", "egzamin ósmoklasisty", "matma bez stresu"]
  },
  energetic: {
    eyebrow: "💪 DLA UCZNIÓW, KTÓRZY CHCĄ ZDAĆ BEZ STRESU!",
    headline: "Matura z matematyki? Załatwione!",
    subheadline: "Zmień stres w pewność siebie - przygotuj się z nami i zdaj powyżej oczekiwań! 🚀 Sprawdzone metody, które działają naprawdę.",
    cta: "🔥 Umów lekcje teraz",
    trustSignals: [
      "✨ 98% zdaje POWYŻEJ oczekiwań!",
      "📈 +35 punktów średnio!",
      "⚡ 8 tygodni = SUKCES!"
    ],
    socialProof: "🔥 47 uczniów zapisało się w tym tygodniu!",
    keywords: ["matura matematyka", "przygotowanie do matury", "korepetycje matematyka", "egzamin ósmoklasisty", "matma bez stresu"]
  }
};
